import { containerDeliveryWorkDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getcontainerDeliveryWorkEn = () => {
  const data = containerDeliveryWorkDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addcontainerDeliveryWork = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-does-container-delivery-work`,
    ) &&
    document.getElementById(`containerDeliveryWorkJSONLD`) === null
  ) {
    const script = containerDeliveryWorkJSONLDEn()
    addJSONLDToHead(script, `containerDeliveryWorkJSONLD`)
  } else {
    removeElement(`containerDeliveryWorkJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const containerDeliveryWorkJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getcontainerDeliveryWorkEn(),
  }
  return FaqBagsterTemplate
}
